//封装全局指令
import Vue from 'vue';

//限制小数位数或限制只能输入数字
Vue.directive('numberLimit', {
  update(el, binding) {
    var bitNumber = binding.value ? Number(binding.value) : 0; //限制的位数
    el.addEventListener("input", (e) => {
      var value = e.target.value; //输入的字符
      var beforeValue = e.target.value;
      if (!bitNumber) {
        //整数
        value = value.replace(/[^\d]/g, '');
      } else {
        //小数
        value = value.replace(/[^\d.]/g, '')
          .replace(/^\./g, '').replace(/\.{2,}/g, '.')
          .replace('.', '$#$').replace(/\./g, '')
          .replace('$#$', '.')
          .slice(0, value.indexOf('.') === -1 ? value.length : value.indexOf('.') + Number(bitNumber) + 1);
      }
      e.target.value = value;
      if (beforeValue != value)
        e.target.dispatchEvent(new Event("input")); //触发更新v-model
    });
  }
});

//可拖拽el-dialog，未完善
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    // 获取拖拽内容头部和整体
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const dragStyle = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    // 鼠标按下事件
    var mousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离 (鼠标点击位置距离可视窗口的距离)
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      const dragDomWidth = dragDom.offsetWidth;
      const dragDomHeight = dragDom.offsetHeight;

      const screenWidth = document.body.clientWidth;
      const screenHeight = document.body.clientHeight;

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight;

      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 组件自带margin,不能移动到最边边，待解决
      if (dragStyle.left.includes('%')) {
        styL = +document.body.clientWidth * (+dragStyle.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+dragStyle.top.replace(/\%/g, '') / 100);
      } else {
        styL = +dragStyle.left.replace(/\px/g, '');
        styT = +dragStyle.top.replace(/\px/g, '');
      };

      // 鼠标拖拽事件
      document.onmousemove = function (e) {
        //计算移动的距离
        var moveleft = e.clientX - disX;
        var moveTop = e.clientY - disY;

        // 边界值判定
        if (-(moveleft) > minDragDomLeft) {
          moveleft = -minDragDomLeft
        } else if (moveleft > maxDragDomLeft) {
          moveleft = maxDragDomLeft
        }

        if (-(moveTop) > minDragDomTop) {
          moveTop = -minDragDomTop
        } else if (moveTop > maxDragDomTop) {
          moveTop = maxDragDomTop
        }

        // 移动当前元素
        dragDom.style.left = `${moveleft + styL}px`;
        dragDom.style.top = `${moveTop + styT}px`;

      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
    // 鼠标按下事件
    dialogHeaderEl.onmousedown = mousedown;

    let nowWidth = 0;
    let nowHight = 0;
    let nowMarginTop = 0;
    let isFullScreen = false;
    //鼠标双击
    dialogHeaderEl.ondblclick = (e) => {
      if (isFullScreen == false) {
        nowHight = dragDom.clientHeight;
        nowWidth = dragDom.clientWidth;
        nowMarginTop = dragDom.style.marginTop;
        dragDom.style.left = 0;
        dragDom.style.top = 0;
        dragDom.style.height = "100VH";
        dragDom.style.width = "100VW";
        dragDom.style.marginTop = 0;
        isFullScreen = true;
        dialogHeaderEl.style.cursor = 'initial';
        dialogHeaderEl.onmousedown = null;
      } else {
        dragDom.style.height = "auto";
        dragDom.style.width = nowWidth + 'px';
        dragDom.style.marginTop = nowMarginTop;
        isFullScreen = false;
        dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.onmousedown = mousedown;
      }
    }
  }
})

//可跳转的下拉框指令
Vue.directive('autoJump', {
  bind(el, binding, vnode) {
    var children = vnode.elm.lastChild;
    var div = document.createElement("div");
    div.className = "zj-auto-jump";
    div.onclick = function () {
      const element = binding.value;
      if (element instanceof Function) {
        element();
      } else {
        vm.routerJump(element)
      }
    }
    var img = document.createElement("div");
    div.appendChild(img);
    children.appendChild(div);
  }
});

//可以显示第一层菜单文字的指令
Vue.directive('menuShowText', {
  bind(el) {
    var menuEl = el.getElementsByClassName('el-tooltip');
    if (menuEl.length) {
      //添加一层span
      for (var i = 0; i < menuEl.length; i++) {
        const oneEl = menuEl[i];
        oneEl.classList.add('menuToolTip');
        oneEl.style = [];
        //找到tooltip的文字
        if (vm) {
          vm.$nextTick(function () {
            if (oneEl.__vue__ && oneEl.__vue__.$refs.popper) {
              var tooltip = oneEl.__vue__.$refs.popper
              if (tooltip) {
                var span = document.createElement("span");
                span.innerText = tooltip.innerText;
                oneEl.appendChild(span);
                tooltip.classList.add('menu-tooltip-x');
                tooltip.innerHTML = "";
                tooltip.style.padding = 0;
              }
            }
          })
        }
      }
    }
  },
  update(el) {
    var interval = setInterval(() => {
      if (vm) {
        clearInterval(interval);
        vm.$nextTick(function () {
          var menuEl = el.getElementsByClassName('el-tooltip');
          if (menuEl.length) {
            //添加一层span
            for (var i = 0; i < menuEl.length; i++) {
              const oneEl = menuEl[i];
              var shouldAddSapn = false;
              if (oneEl.className.indexOf('menuToolTip') == -1) {
                oneEl.classList.add('menuToolTip');
                oneEl.style = [];
                shouldAddSapn = true;
              }
              //找到tooltip的文字
              if (oneEl.__vue__ && oneEl.__vue__.$refs.popper) {
                var tooltip = oneEl.__vue__.$refs.popper
                if (tooltip) {
                  if (shouldAddSapn) {
                    var span = document.createElement("span");
                    span.innerText = tooltip.innerText;
                    oneEl.appendChild(span);
                  }
                  tooltip.classList.add('menu-tooltip-x');
                  tooltip.innerHTML = "";
                  tooltip.style.padding = 0;
                }
              }
            }
          }
        })
      }
    }, 10);
  }
});

//权限指令，不局限于按钮
Vue.directive('hasElement', {
  bind(el, binding) {
    const element = binding.value;
    if (element && ((element instanceof Array && element.length > 0 && element.length < 3) || typeof element == "string")) {
      //权限按钮与页面在同一页面时可以不用传menu_link
      const routerName = typeof element == "string" ?
        vm.$route.name :
        (element instanceof Array && element.length == 2 ? element[1] : vm.$route.name);
      //权限代码
      const codeName = typeof element == "string" ?
        element :
        (element instanceof Array ? element[0] : "");
      var hasEl = vm.$store.state.navTabs.menuTreeListFlatten.filter(item => item.menu_link == routerName)
      if (hasEl.length) {
        hasEl = hasEl[0].check_elements.filter(item => item.element_code == codeName)
        if (hasEl.length) {
          //匹配到权限
          return;
        }
      }
      //没有权限移除元素
      vm.$nextTick(function () {
        el.parentNode && el.parentNode.removeChild(el)
      })
    } else {
      throw new Error(`传递参数格式 v-hasElement="['element_code','menu_link']" 或者 v-hasElement="element_code" 权限按钮与页面在同一页面时可以不用传menu_link`)
    }
  }
});